<template>
  <modal
    name="edit-daily-answers"
    transition="pop-out"
    :classes="'modal fade show'"
    :height="modalHeight"
    :resizable="false"
    :pivot-y="0.05"
    @before-open="beforeOpen"
  >
    <div class="modal-dialog ui-block window-popup create-event">
      <a
        href="#"
        class="close icon-close"
        aria-label="Close"
        @click="$modal.hide('edit-daily-answers')"
      >
        <app-icon
          name="olymp-close-icon"
          color="black"
          size="small"
        />
      </a>
      <div class="fl-msg" />
      <!--<flash-message class="fl-msg"></flash-message>-->

      <div class="ui-block-title">
        <h6 class="title">
          Edit Answer
        </h6>
      </div>

      <div class="ui-block-content">
        <ol v-if="questions && questions.length">
          <li
            v-for="quest in questions"
            :key="quest.id"
            class="padding10"
          >
            {{ quest.title }}
          </li>
        </ol>

        <form
          class="content"
          @submit.prevent="editAnswer"
        >
          <div
            v-if="a"
            class="row"
          >
            <div class="col-xl-12 col-lg-12 col-md-12">
              <div class="form-group label-floating">
                <label class="control-label">Answer</label>
                <wysiwyg v-model="a.description" />
              </div>
            </div>
          </div>
          <button
            class="btn btn-lg btn-breez full-width"
            type="submit"
            name="submit"
          >
            <span>Edit Answer</span>
          </button>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import VModal from 'vue-js-modal';
import Vue from 'vue'
Vue.use(VModal, {dialog: true});
import wysiwyg from 'vue-wysiwyg'
import '../../../../node_modules/vue-wysiwyg/dist/vueWysiwyg.css'
Vue.use(wysiwyg, {
  // { [module]: boolean (set true to hide) }
  hideModules: {
    bold: false,
    italic: false,
    underline: false,
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    headings: true,
    link: false,
    code: false,
    orderedList: true,
    unorderedList: true,
    image: false,
    table: true
  },
  // image: {
  //   uploadURL: IMAGE_URL,
  //   dropzoneOptions: {}
  // },
  forcePlainTextOnPaste: true
})

const MODAL_HEIGHT = 500

import AppIcon from "../../common-apps/common/AppIcon"

export default {
  name: 'EditDailyAnswers',
  components: { AppIcon },
  data () {
    return {
      modalHeight: MODAL_HEIGHT,
      a: {}
    }
  },
  computed: mapState({
    questions: state => state.dailyAnswers ? state.dailyAnswers.questions : []
  }),
  methods: {
    beforeOpen (event) {
      this.a.id = event.params.id
      this.a.description = event.params.description
      this.$store.dispatch('dailyAnswers/getQuestions')
    },
    // eslint-disable-next-line
    editAnswer: function() { // !!!! this messes up if I use arrow function
      // if (this.isValid) {
      // eslint-disable-next-line
      const payload = {
        description: this.a.description,
        id: this.a.id
      }
      this.$store.dispatch('dailyAnswers/edit', payload)
    }
  }
}
</script>

<style lang="scss" scoped>
  .v--modal {
    background-color: white;
    text-align: left;
    border-radius: 3px;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
    overflow-y: auto !important;
  }

</style>
